import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable'
import { Response } from '../models/response.model';
import { Profil } from '../models/profil.model';

@Injectable({
  providedIn: 'root'
})
export class ProfilService {

  apiUrl = '/api/kullanici'
  
  constructor(private http: HttpClient) { }

  getByTCKimlikNo(tckimlikno: number): Observable<Profil> {
    return this.http.get<Profil>(this.apiUrl + '/getbyTCKimlikNo?tckimlikno=' + tckimlikno);
  }

  getById(id: number): Observable<Profil> {
    return this.http.get<Profil>(this.apiUrl + '/getById?id=' + id);
  }
  
  addUpdate(kullanici: Profil): Observable<Response<Profil>> {
    return this.http.post<Response<Profil>>("api/kullanici/update",kullanici)  
  }

  smsSend(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this.apiUrl + '/smsSend');
  }

  smsCheck(dogrulamaKod: string): Observable<Response<any>> {
    return this.http.post<Response<any>>(this.apiUrl + '/smsCheck?smsGelenKod='+dogrulamaKod,{});
  }

}
